import { AccountActions } from "../action-types/accountActionTypes";

const initialState = {
  accountDetailsData: [],

  models: {
    EditUserAccountPasswordModel: "",
  },
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case AccountActions.SET_USER_ACCOUNT_DETAILS_LIST:
      return {
        ...state,
        accountDetailsData: action.payload,
      };
    case AccountActions.IS_OPEN_MODELS_EDIT_USER_ACCOUNT_PASSWORD:
      return {
        ...state,
        models: {
          ...state.models,
          EditUserAccountPasswordModel: action.payload,
        },
      };
    default:
      return state;
  }
};

export default accountReducer;
